import React from 'react';
import Header from 'src/components/header';
import Footer from 'src/components/footer';
import './style.scss';
import { noop } from 'lodash';

/**
 * Layout component - Main page layout with header, main content and footer.
 * 
 * @param {Object} props - Props for the Layout component.
 * @param {React.ReactNode} props.children - The children elements. 
 * @returns {JSX.Element} The Layout component.
 * @example
 *  <Layout>
 *      ...
 *  </Layout>
 */
function Layout({ children }) {
    return (
        <div className="default-layout">
            <Header />
            <div className="app-content">
                {children}
            </div>
            <Footer />
        </div>
    );
}

Layout.defaultProps = {
    children: noop
}

export default Layout;
